import { useLocation } from '../../common/hooks/routerCompat';

export const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};
